import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { SharedModule } from '../../../shared/shared.module';
import { AuthService } from '../../../../core/services/auth.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [SharedModule, ReactiveFormsModule],
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required]]
  });
  viewLoading = false;
  loading = false;
  inValidLogin = false;

  constructor(private fb: FormBuilder,
    private authService: AuthService,
    private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe(async params => {
      const clientKey = params.get('client_key');
      const secretKey = params.get('secret_key');

      if (clientKey && secretKey) {

        this.viewLoading = true;
        await this.onSubmit(clientKey, secretKey);
      }
    });
  }

  async onSubmit(clientKey: string = null, secretKey: string = null): Promise<void> {
    this.loading = true;

    if (this.loginForm.invalid && !clientKey && !secretKey) {
      this.loading = false;
      return;
    }

    const formValue = {
      ...this.loginForm.value,
      clientKey: clientKey,
      secretKey: secretKey
    };

    const success = await this.authService.logIn(formValue);

    if (success) {
      window.location.href = '/home';
      this.inValidLogin = false;
    } else {
      this.inValidLogin = true;
      this.viewLoading = false;
      this.loading = false;
    }

  }
}
